<script>
  import { onMount } from 'svelte'

  export let data

  // import Picker from 'vanilla-picker'

  onMount(async () => {
    var parent = document.querySelector('#primary-color')
    var picker = new Picker(parent)

    // You can do what you want with the chosen color using two callbacks: onChange and onDone.
    picker.onChange = function(color) {
      parent.style.background = color.rgbaString
      let root = document.documentElement
      root.style.setProperty('--primary-color', color.rgbaString)
      data.design.color = color.rgbaString
    }

    picker.onDone = function(color) {
      //saveData()
      let root = document.documentElement
      root.style.setProperty('--primary-color', color.rgbaString)
      data.design.color = color.rgbaString
      saveData()
    }

    var parent2 = document.querySelector('#secondary-color')
    var picker2 = new Picker(parent2)

    // You can do what you want with the chosen color using two callbacks: onChange and onDone.
    picker2.onChange = function(color) {
      parent2.style.background = color.rgbaString
      let root = document.documentElement
      root.style.setProperty('--secondary-color', color.rgbaString)
      data.design.color2 = color.rgbaString
    }

    picker2.onDone = function(color) {
      //saveData()
      let root = document.documentElement
      root.style.setProperty('--secondary-color', color.rgbaString)
      data.design.color2 = color.rgbaString
      saveData()
    }
  })

  function changeFont() {
    let font = document.querySelector('#font-select').value
    document.querySelector('#font').href = 'fonts/' + font + '.css'
    data.design.font = font
    saveData()
  }

  function saveData() {
    localStorage.setItem('json', JSON.stringify(data))
  }
</script>

<label class="d-block mt-4">Color Palette</label>
<ul class="list-group">
  <li class="list-group-item pl-3">
    <div
      id="primary-color"
      class="swatch"
      style="background-color: var(--primary-color);" />
    <div
      id="secondary-color"
      class="swatch"
      style="background-color: var(--secondary-color);" />
  </li>
</ul>

<label class="d-block mt-4">Fonts</label>

    <select
      id="font-select"
      class="form-control w-100"
      on:change={changeFont}
      bind:value={data.design.font}>
      <option value="PlayfairDisplay-Muli">Default</option>
      <option value="Inter">Inter</option>
      <option value="Lobster-Cabin">Lobster &amp; Cabin</option>
      <option value="Raleway-Goudy">Raleway &amp; Goudy</option>
      <option value="Arvo-PTsans">Arvo &amp; PTSans</option>
      <option value="DroidSerif-Sans">Droid Serif &amp; Droid Sans</option>
      <option value="Ubuntu-Vollkorn">Ubuntu &amp; Vollkorn</option>
      <option value="Pacifico-Arimo">Pacifico &amp; Arimo</option>
    </select>


<style>
  .swatch {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #000;
    margin-right: 5px;
    border: 1px solid #ddd;
    display: inline-block;
    vertical-align: middle;
  }
</style>
